import { useState } from 'react';
import { Box, Button, Typography } from '@mui/joy';
import useChatMedia from '../../hooks/useChatMedia';
import { openChatAttachment } from '../../utils/chatMedia';

export default function ChatMediaPhoto({ attachment, chatId, messageId, single, onOpen }) {
  const media = useChatMedia(attachment, chatId, messageId);
  const [downloadError, setDownloadError] = useState('');
  const failed = Boolean(media.error || !media.url);
  const download = async event => {
    event.stopPropagation(); setDownloadError('');
    try { await openChatAttachment(attachment, chatId, messageId); }
    catch (error) { setDownloadError(error.message); }
  };
  return (
    <Box sx={{ width: '100%', minWidth: single ? 180 : 90, minHeight: single ? 120 : 90,
      position: 'relative', aspectRatio: single ? undefined : '1 / 1' }}>
      {!failed && <img key={`${media.url}:${media.version}`} src={media.url} alt={attachment.name || 'Фото'}
        loading="lazy" decoding="async" crossOrigin="anonymous" referrerPolicy="no-referrer" onLoad={() => setDownloadError('')}
        onError={media.onError} onClick={() => onOpen(media.url)}
        style={{ display: 'block', width: '100%', height: single ? 'auto' : '100%',
          minHeight: single ? 120 : 90, maxHeight: single ? 320 : undefined,
          objectFit: 'cover', cursor: 'pointer' }} />}
      {(failed || media.loading) && <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1,
        minHeight: 120, justifyContent: 'center', backgroundColor: 'background.surface', lineHeight: 1.4 }}>
        <Typography level="body-sm" sx={{ color: 'text.primary', overflowWrap: 'anywhere' }}>
          {attachment.name || 'Фото'}
        </Typography>
        <Typography level="body-xs" sx={{ color: 'text.secondary' }}>
          {media.loading ? 'Обновляем ссылку…' : media.error || 'Файл пока недоступен'}
        </Typography>
        {!media.loading && <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <Button size="sm" variant="soft" onClick={event => { event.stopPropagation(); media.retry(); }}>Повторить</Button>
          <Button size="sm" variant="plain" onClick={download}>Скачать</Button>
        </Box>}
      </Box>}
      {downloadError && <Typography level="body-xs" sx={{ p: 1, color: 'danger.600', lineHeight: 1.4 }}>{downloadError}</Typography>}
    </Box>
  );
}
